import React, { useMemo, useState } from 'react';
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Container,
  Grid,
  Group,
  NumberInput,
  Paper,
  Radio,
  Select,
  SimpleGrid,
  Stack,
  Stepper,
  Text,
  TextInput,
  Textarea,
  ThemeIcon,
  Title,
} from '@mantine/core';
import {
  IconArrowLeft,
  IconCalendarEvent,
  IconChecklist,
  IconClipboardText,
  IconDeviceLaptop,
  IconInfoCircle,
  IconPlus,
  IconReceipt2,
  IconSend,
  IconSparkles,
  IconTrash,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const departments = [
  { value: 'Bilgi İşlem', label: 'Bilgi İşlem' },
  { value: 'İdari İşler', label: 'İdari İşler' },
  { value: 'Şantiye Operasyon', label: 'Şantiye Operasyon' },
  { value: 'Muhasebe', label: 'Muhasebe' },
  { value: 'İnsan Kaynakları', label: 'İnsan Kaynakları' },
];

const expenseAreasByDepartment = {
  'Bilgi İşlem': [
    { value: 'BT', label: 'BT' },
    { value: 'Yazılım', label: 'Yazılım' },
    { value: 'Donanım', label: 'Donanım' },
    { value: 'Ağ ve Altyapı', label: 'Ağ ve Altyapı' },
  ],
  'İdari İşler': [
    { value: 'Kırtasiye', label: 'Kırtasiye' },
    { value: 'Temizlik', label: 'Temizlik' },
    { value: 'Ofis Sarf', label: 'Ofis Sarf' },
    { value: 'Demirbaş', label: 'Demirbaş' },
  ],
  'Şantiye Operasyon': [
    { value: 'Mekanik', label: 'Mekanik' },
    { value: 'Elektrik', label: 'Elektrik' },
    { value: 'İnşaat', label: 'İnşaat' },
    { value: 'İSG', label: 'İSG' },
  ],
  Muhasebe: [
    { value: 'Muhasebe Sarf', label: 'Muhasebe Sarf' },
    { value: 'Arşiv', label: 'Arşiv' },
  ],
  'İnsan Kaynakları': [
    { value: 'Eğitim', label: 'Eğitim' },
    { value: 'Ofis Sarf', label: 'Ofis Sarf' },
    { value: 'Organizasyon', label: 'Organizasyon' },
  ],
};

const materialCatalog = [
  {
    code: 'BT-0001',
    label: 'BT-0001 - Dell Latitude 15 Laptop',
    description: 'Dell Latitude 15 Laptop',
    uom: 'Adet',
    unitPrice: 42000,
    category: 'BT',
  },
  {
    code: 'BT-0002',
    label: 'BT-0002 - Laptop Çantası',
    description: 'Laptop Çantası',
    uom: 'Adet',
    unitPrice: 1750,
    category: 'BT',
  },
  {
    code: 'BT-0003',
    label: 'BT-0003 - Kablosuz Mouse',
    description: 'Kablosuz Mouse',
    uom: 'Adet',
    unitPrice: 550,
    category: 'BT',
  },
  {
    code: 'KRT-0001',
    label: 'KRT-0001 - A4 Fotokopi Kağıdı',
    description: 'A4 Fotokopi Kağıdı',
    uom: 'Koli',
    unitPrice: 450,
    category: 'Kırtasiye',
  },
  {
    code: 'KRT-0002',
    label: 'KRT-0002 - Tükenmez Kalem',
    description: 'Tükenmez Kalem',
    uom: 'Adet',
    unitPrice: 18,
    category: 'Kırtasiye',
  },
  {
    code: 'ELK-0001',
    label: 'ELK-0001 - NYM Kablo',
    description: 'NYM Kablo',
    uom: 'Paket',
    unitPrice: 3200,
    category: 'Elektrik',
  },
  {
    code: 'MKN-0001',
    label: 'MKN-0001 - Spiral Boru',
    description: 'Spiral Boru',
    uom: 'Adet',
    unitPrice: 850,
    category: 'Mekanik',
  },
  {
    code: 'INS-0001',
    label: 'INS-0001 - Çimento',
    description: 'Çimento',
    uom: 'Adet',
    unitPrice: 265,
    category: 'İnşaat',
  },
];

const requesters = [
  { value: 'Muhammed Selvi', label: 'Muhammed Selvi' },
  { value: 'Ayşe Kaya', label: 'Ayşe Kaya' },
  { value: 'Emre Demir', label: 'Emre Demir' },
  { value: 'Hüseyin Aydın', label: 'Hüseyin Aydın' },
];

const priorities = [
  { value: 'LOW', label: 'Düşük' },
  { value: 'MEDIUM', label: 'Orta' },
  { value: 'HIGH', label: 'Yüksek' },
  { value: 'CRITICAL', label: 'Kritik' },
];

const currencies = [
  { value: 'TRY', label: 'TRY' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
];

const uoms = [
  { value: 'Adet', label: 'Adet' },
  { value: 'Koli', label: 'Koli' },
  { value: 'Hizmet', label: 'Hizmet' },
  { value: 'Lisans', label: 'Lisans' },
  { value: 'Paket', label: 'Paket' },
];

const draftTemplates = [
  {
    id: 'tpl-1',
    title: 'Yeni Personel IT Seti',
    description: 'Laptop, çanta ve aksesuar alımı için örnek taslak.',
    department: 'Bilgi İşlem',
    requestType: 'Ürün',
  },
  {
    id: 'tpl-2',
    title: 'Ofis Sarf Malzeme',
    description: 'Aylık tüketim malzemeleri için standart talep.',
    department: 'İdari İşler',
    requestType: 'Ürün',
  },
  {
    id: 'tpl-3',
    title: 'Kurulum ve Teknik Hizmet',
    description: 'Hizmet tipi talep oluşturmak için örnek kurgu.',
    department: 'Bilgi İşlem',
    requestType: 'Hizmet',
  },
];

const priorityConfig = {
  LOW: { color: 'gray', label: 'Düşük' },
  MEDIUM: { color: 'blue', label: 'Orta' },
  HIGH: { color: 'orange', label: 'Yüksek' },
  CRITICAL: { color: 'red', label: 'Kritik' },
};

const currencyFormatter = new Intl.NumberFormat('tr-TR', {
  style: 'currency',
  currency: 'TRY',
  maximumFractionDigits: 2,
});

function SummaryCard({ icon: Icon, color, title, value, subtitle }) {
  return (
    <Card withBorder radius="lg" p="lg" shadow="sm">
      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Text size="sm" c="dimmed" fw={500}>
            {title}
          </Text>
          <Text fw={800} size="1.55rem" lh={1.1}>
            {value}
          </Text>
          <Text size="xs" c="dimmed">
            {subtitle}
          </Text>
        </Stack>

        <ThemeIcon color={color} variant="light" size={46} radius="md">
          <Icon size={22} />
        </ThemeIcon>
      </Group>
    </Card>
  );
}

function SectionCard({ title, description, children, action }) {
  return (
    <Paper withBorder radius="lg" p="lg" shadow="sm">
      <Group justify="space-between" align="flex-start" mb="md">
        <Box>
          <Title order={4}>{title}</Title>
          {description ? (
            <Text size="sm" c="dimmed" mt={4}>
              {description}
            </Text>
          ) : null}
        </Box>
        {action}
      </Group>
      {children}
    </Paper>
  );
}

function InfoRow({ label, value }) {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap">
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Text size="sm" fw={600} ta="right">
        {value || '-'}
      </Text>
    </Group>
  );
}

export default function ProcurementRequestCreatePage() {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);

  const [form, setForm] = useState({
    requestNo: 'PR-2026-0104',
    title: 'Yeni personel için çalışma ekipmanı talebi',
    department: 'Bilgi İşlem',
    expenseArea: 'BT',
    requester: 'Muhammed Selvi',
    priority: 'HIGH',
    currency: 'TRY',
    requestType: 'Ürün',
    needByDate: '2026-03-25',
    costCenter: 'Merkez Ofis / BT',
    justification:
      'Yeni başlayan personelin işe girişinde ihtiyaç duyacağı ekipmanların zamanında hazır edilmesi amaçlanmaktadır.',
    note: 'Teklif sürecinde en az 2 tedarikçiden fiyat toplanması planlanmaktadır.',
  });

  const [lines, setLines] = useState([
    {
      id: 'LINE-1',
      materialCode: 'BT-0001',
      description: 'Dell Latitude 15 Laptop',
      quantity: 1,
      uom: 'Adet',
      unitPrice: 42000,
      requiredDate: '2026-03-25',
    },
    {
      id: 'LINE-2',
      materialCode: 'BT-0002',
      description: 'Laptop Çantası',
      quantity: 1,
      uom: 'Adet',
      unitPrice: 1750,
      requiredDate: '2026-03-25',
    },
    {
      id: 'LINE-3',
      materialCode: 'BT-0003',
      description: 'Kablosuz Mouse',
      quantity: 1,
      uom: 'Adet',
      unitPrice: 550,
      requiredDate: '2026-03-25',
    },
  ]);

  const availableExpenseAreas = expenseAreasByDepartment[form.department] || [];

  const filteredMaterials = useMemo(() => {
    if (!form.expenseArea) return materialCatalog;
    return materialCatalog.filter((item) => item.category === form.expenseArea);
  }, [form.expenseArea]);

  const materialOptions = filteredMaterials.map((item) => ({
    value: item.code,
    label: item.label,
  }));

  const updateForm = (field, value) => {
    if (field === 'department') {
      const nextExpenseAreas = expenseAreasByDepartment[value] || [];
      const nextExpenseArea = nextExpenseAreas[0]?.value || '';
      setForm((prev) => ({
        ...prev,
        department: value || '',
        expenseArea: nextExpenseArea,
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const addLine = () => {
    setLines((prev) => [
      ...prev,
      {
        id: `LINE-${prev.length + 1}`,
        materialCode: '',
        description: '',
        quantity: 1,
        uom: 'Adet',
        unitPrice: 0,
        requiredDate: form.needByDate,
      },
    ]);
  };

  const updateLine = (id, field, value) => {
    setLines((prev) =>
      prev.map((line) => {
        if (line.id !== id) return line;

        if (field === 'materialCode') {
          const selectedMaterial = materialCatalog.find((item) => item.code === value);
          if (!selectedMaterial) {
            return {
              ...line,
              materialCode: value || '',
            };
          }

          return {
            ...line,
            materialCode: selectedMaterial.code,
            description: selectedMaterial.description,
            uom: selectedMaterial.uom,
            unitPrice: selectedMaterial.unitPrice,
          };
        }

        return { ...line, [field]: value };
      })
    );
  };

  const removeLine = (id) => {
    setLines((prev) => prev.filter((line) => line.id !== id));
  };

  const totals = useMemo(() => {
    const lineCount = lines.length;
    const totalQty = lines.reduce((acc, line) => acc + Number(line.quantity || 0), 0);
    const totalAmount = lines.reduce(
      (acc, line) => acc + Number(line.quantity || 0) * Number(line.unitPrice || 0),
      0
    );

    return { lineCount, totalQty, totalAmount };
  }, [lines]);

  const selectedPriority = priorityConfig[form.priority] || priorityConfig.MEDIUM;

  const stepper = (
    <Stepper active={activeStep} onStepClick={setActiveStep} allowNextStepsSelect size="sm">
      <Stepper.Step label="Temel Bilgiler" description="Başlık ve ihtiyaç özeti" />
      <Stepper.Step label="Kalemler" description="Satır bazlı giriş" />
      <Stepper.Step label="Kontrol" description="Ön izleme ve gönderim" />
    </Stepper>
  );

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Paper
          withBorder
          radius="xl"
          p="xl"
          shadow="sm"
          style={{
            background:
              'linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(255,255,255,1) 100%)',
          }}
        >
          <Group justify="space-between" align="flex-start" gap="xl">
            <Stack gap="sm" maw={820}>
              <Group gap="sm">
                <Button
                  variant="subtle"
                  leftSection={<IconArrowLeft size={16} />}
                  px={0}
                  onClick={() => navigate('/purchase-dashboard')}
                >
                  Geri Dön
                </Button>
                <Badge variant="light" color="blue" leftSection={<IconSparkles size={14} />}>
                  Statik demo sayfa
                </Badge>
              </Group>

              <div>
                <Title order={1}>Talep Oluşturma</Title>
                <Text size="sm" c="dimmed" mt="sm">
                  Satın alma sürecinin ilk adımı olan talep giriş ekranı. Burada departman, harcama alanı,
                  talep eden kişi, ihtiyaç gerekçesi ve kalem bazlı bilgiler toplanır. Bu yapı daha sonra
                  onay ve teklif sürecine temel oluşturur.
                </Text>
              </div>
            </Stack>
          </Group>

          <SimpleGrid cols={{ base: 1, sm: 2, xl: 4 }} spacing="md" mt="xl">
            <SummaryCard
              icon={IconClipboardText}
              color="blue"
              title="Talep Numarası"
              value={form.requestNo}
              subtitle="Otomatik üretilmiş demo belge no"
            />
            <SummaryCard
              icon={IconChecklist}
              color="teal"
              title="Kalem Sayısı"
              value={totals.lineCount}
              subtitle="Satır bazlı ihtiyaç girişi"
            />
            <SummaryCard
              icon={IconReceipt2}
              color="orange"
              title="Toplam Tutar"
              value={currencyFormatter.format(totals.totalAmount)}
              subtitle="Tahmini bütçe büyüklüğü"
            />
            <SummaryCard
              icon={IconCalendarEvent}
              color="grape"
              title="İhtiyaç Tarihi"
              value={form.needByDate}
              subtitle="Tedarik tamamlanma hedefi"
            />
          </SimpleGrid>
        </Paper>

        <Paper withBorder radius="lg" p="lg" shadow="sm">
          {stepper}
        </Paper>

        <Grid gutter="lg">
          <Grid.Col span={{ base: 12, xl: 8 }}>
            <Stack gap="lg">
              <SectionCard
                title="Talep Şablonları"
                description="Hızlı başlangıç için hazır örnek senaryolar. Statik demoda sadece görsel amaçlıdır."
              >
                <SimpleGrid cols={{ base: 1, md: 3 }} spacing="md">
                  {draftTemplates.map((template) => (
                    <Card key={template.id} withBorder radius="lg" p="md">
                      <Stack gap="sm">
                        <Group justify="space-between" align="flex-start">
                          <Text fw={700}>{template.title}</Text>
                          <Badge variant="light">{template.requestType}</Badge>
                        </Group>
                        <Text size="sm" c="dimmed">
                          {template.description}
                        </Text>
                        <Group justify="space-between" align="center">
                          <Text size="xs" c="dimmed">
                            {template.department}
                          </Text>
                          <Button variant="light" size="xs">
                            Uygula
                          </Button>
                        </Group>
                      </Stack>
                    </Card>
                  ))}
                </SimpleGrid>
              </SectionCard>

              <SectionCard
                title="Temel Talep Bilgileri"
                description="Talebin kime ait olduğu, hangi departmandan geldiği, hangi alanda harcanacağı ve neden açıldığı burada tanımlanır."
              >
                <Grid gutter="md">
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <TextInput
                      label="Talep No"
                      value={form.requestNo}
                      onChange={(event) => updateForm('requestNo', event.currentTarget.value)}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <TextInput
                      label="Talep Başlığı"
                      value={form.title}
                      onChange={(event) => updateForm('title', event.currentTarget.value)}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <Select
                      label="Departman"
                      data={departments}
                      value={form.department}
                      onChange={(value) => updateForm('department', value || '')}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <Select
                      label="Harcama Alanı"
                      data={availableExpenseAreas}
                      value={form.expenseArea}
                      onChange={(value) => updateForm('expenseArea', value || '')}
                      disabled={!form.department}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <Select
                      label="Talep Eden"
                      data={requesters}
                      value={form.requester}
                      onChange={(value) => updateForm('requester', value || '')}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <Select
                      label="Öncelik"
                      data={priorities}
                      value={form.priority}
                      onChange={(value) => updateForm('priority', value || 'MEDIUM')}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <Select
                      label="Para Birimi"
                      data={currencies}
                      value={form.currency}
                      onChange={(value) => updateForm('currency', value || 'TRY')}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <TextInput
                      label="Masraf Merkezi"
                      value={form.costCenter}
                      onChange={(event) => updateForm('costCenter', event.currentTarget.value)}
                    />
                  </Grid.Col>

                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <TextInput
                      label="İhtiyaç Tarihi"
                      type="date"
                      value={form.needByDate}
                      onChange={(event) => updateForm('needByDate', event.currentTarget.value)}
                    />
                  </Grid.Col>

                  <Grid.Col span={12}>
                    <Radio.Group
                      label="Talep Türü"
                      value={form.requestType}
                      onChange={(value) => updateForm('requestType', value)}
                    >
                      <Group mt="xs">
                        <Radio value="Ürün" label="Ürün / Ekipman" />
                        <Radio value="Hizmet" label="Hizmet / İşçilik" />
                        <Radio value="Lisans" label="Yazılım / Lisans" />
                      </Group>
                    </Radio.Group>
                  </Grid.Col>

                  <Grid.Col span={12}>
                    <Textarea
                      label="Talep Gerekçesi"
                      minRows={4}
                      value={form.justification}
                      onChange={(event) => updateForm('justification', event.currentTarget.value)}
                    />
                  </Grid.Col>

                  <Grid.Col span={12}>
                    <Textarea
                      label="Ek Not"
                      minRows={3}
                      value={form.note}
                      onChange={(event) => updateForm('note', event.currentTarget.value)}
                    />
                  </Grid.Col>
                </Grid>
              </SectionCard>

              <SectionCard
                title="Talep Kalemleri"
                description="Her satır ileride teklif toplama ve onay sürecinde ayrı ayrı karşılaştırılabilir. Malzeme kodu seçildiğinde açıklama ve fiyat otomatik gelir."
                action={
                  <Button leftSection={<IconPlus size={16} />} onClick={addLine}>
                    Kalem Ekle
                  </Button>
                }
              >
                <Stack gap="md">
                  {lines.map((line, index) => (
                    <Paper key={line.id} withBorder radius="md" p="md">
                      <Stack gap="md">
                        <Group justify="space-between" align="center">
                          <Group gap="xs">
                            <ThemeIcon variant="light" color="blue" radius="md">
                              <IconDeviceLaptop size={16} />
                            </ThemeIcon>
                            <div>
                              <Text fw={700}>Kalem {index + 1}</Text>
                              <Text size="xs" c="dimmed">
                                Satır bazlı ihtiyaç bilgisi
                              </Text>
                            </div>
                          </Group>

                          <ActionIcon color="red" variant="light" onClick={() => removeLine(line.id)}>
                            <IconTrash size={16} />
                          </ActionIcon>
                        </Group>

                        <Grid gutter="md">
                          <Grid.Col span={{ base: 12, md: 4 }}>
                            <Select
                              label="Malzeme Kodu"
                              data={materialOptions}
                              value={line.materialCode}
                              onChange={(value) => updateLine(line.id, 'materialCode', value || '')}
                              placeholder="Malzeme kodu seçin"
                              searchable
                            />
                          </Grid.Col>

                          <Grid.Col span={{ base: 12, md: 4 }}>
                            <TextInput
                              label="Açıklama"
                              value={line.description}
                              onChange={(event) =>
                                updateLine(line.id, 'description', event.currentTarget.value)
                              }
                              placeholder="Ürün veya hizmet açıklaması"
                            />
                          </Grid.Col>

                          <Grid.Col span={{ base: 12, md: 2 }}>
                            <NumberInput
                              label="Miktar"
                              value={line.quantity}
                              min={1}
                              onChange={(value) =>
                                updateLine(line.id, 'quantity', Number(value) || 0)
                              }
                            />
                          </Grid.Col>

                          <Grid.Col span={{ base: 12, md: 2 }}>
                            <Select
                              label="Birim"
                              data={uoms}
                              value={line.uom}
                              onChange={(value) => updateLine(line.id, 'uom', value || 'Adet')}
                            />
                          </Grid.Col>

                          <Grid.Col span={{ base: 12, md: 4 }}>
                            <NumberInput
                              label="Tahmini Birim Fiyat"
                              value={line.unitPrice}
                              min={0}
                              thousandSeparator="."
                              decimalSeparator=","
                              onChange={(value) =>
                                updateLine(line.id, 'unitPrice', Number(value) || 0)
                              }
                            />
                          </Grid.Col>

                          <Grid.Col span={{ base: 12, md: 4 }}>
                            <TextInput
                              label="İhtiyaç Tarihi"
                              type="date"
                              value={line.requiredDate}
                              onChange={(event) =>
                                updateLine(line.id, 'requiredDate', event.currentTarget.value)
                              }
                            />
                          </Grid.Col>

                          <Grid.Col span={{ base: 12, md: 4 }}>
                            <Paper radius="md" p="sm" bg="gray.0" mt={25}>
                              <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                  Satır Tutarı
                                </Text>
                                <Text fw={700}>
                                  {currencyFormatter.format(
                                    Number(line.quantity || 0) * Number(line.unitPrice || 0)
                                  )}
                                </Text>
                              </Group>
                            </Paper>
                          </Grid.Col>
                        </Grid>
                      </Stack>
                    </Paper>
                  ))}
                </Stack>
              </SectionCard>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, xl: 4 }}>
            <Stack gap="lg">
              <SectionCard
                title="Ön İzleme"
                description="Talep gönderilmeden önce oluşacak özet görünüm."
              >
                <Stack gap="sm">
                  <InfoRow label="Talep No" value={form.requestNo} />
                  <InfoRow label="Başlık" value={form.title} />
                  <InfoRow label="Departman" value={form.department} />
                  <InfoRow label="Harcama Alanı" value={form.expenseArea} />
                  <InfoRow label="Talep Eden" value={form.requester} />
                  <InfoRow
                    label="Öncelik"
                    value={
                      <Badge color={selectedPriority.color} variant="light">
                        {selectedPriority.label}
                      </Badge>
                    }
                  />
                  <InfoRow label="Talep Türü" value={form.requestType} />
                  <InfoRow label="Masraf Merkezi" value={form.costCenter} />
                  <InfoRow label="İhtiyaç Tarihi" value={form.needByDate} />
                  <InfoRow label="Toplam Kalem" value={totals.lineCount} />
                  <InfoRow label="Toplam Miktar" value={totals.totalQty} />
                  <InfoRow label="Tahmini Tutar" value={currencyFormatter.format(totals.totalAmount)} />
                </Stack>
              </SectionCard>

              <SectionCard
                title="Süreç Bilgilendirmesi"
                description="Bu ekranın sonraki adımlarla ilişkisi."
              >
                <Stack gap="md">
                  <Paper withBorder radius="md" p="sm">
                    <Group align="flex-start" wrap="nowrap">
                      <ThemeIcon color="blue" variant="light" mt={2}>
                        <IconClipboardText size={16} />
                      </ThemeIcon>
                      <div>
                        <Text fw={600} size="sm">
                          1. Talep Girişi
                        </Text>
                        <Text size="xs" c="dimmed" mt={2}>
                          Bu sayfada temel bilgiler ve satırlar oluşturulur.
                        </Text>
                      </div>
                    </Group>
                  </Paper>

                  <Paper withBorder radius="md" p="sm">
                    <Group align="flex-start" wrap="nowrap">
                      <ThemeIcon color="orange" variant="light" mt={2}>
                        <IconChecklist size={16} />
                      </ThemeIcon>
                      <div>
                        <Text fw={600} size="sm">
                          2. Talep Onayı
                        </Text>
                        <Text size="xs" c="dimmed" mt={2}>
                          Departman ve tutara göre ilgili onay mercileri devreye girer.
                        </Text>
                      </div>
                    </Group>
                  </Paper>

                  <Paper withBorder radius="md" p="sm">
                    <Group align="flex-start" wrap="nowrap">
                      <ThemeIcon color="teal" variant="light" mt={2}>
                        <IconReceipt2 size={16} />
                      </ThemeIcon>
                      <div>
                        <Text fw={600} size="sm">
                          3. Teklif Toplama
                        </Text>
                        <Text size="xs" c="dimmed" mt={2}>
                          Onaylanan talep için tedarikçi teklifleri ayrı ekranda toplanır.
                        </Text>
                      </div>
                    </Group>
                  </Paper>
                </Stack>
              </SectionCard>

              <SectionCard
                title="Aksiyonlar"
                description="Demo olduğu için butonlar görsel amaçlıdır."
              >
                <Stack gap="sm">
                  <Button variant="default" fullWidth>
                    Taslak Kaydet
                  </Button>
                  <Button leftSection={<IconSend size={16} />} fullWidth>
                    Onaya Gönder
                  </Button>
                  <Button variant="light" color="gray" fullWidth>
                    Formu Temizle
                  </Button>
                </Stack>
              </SectionCard>
            </Stack>
          </Grid.Col>
        </Grid>

        <Paper withBorder radius="lg" p="md" shadow="sm" style={{ borderStyle: 'dashed' }}>
          <Group align="flex-start" wrap="nowrap">
            <ThemeIcon color="blue" variant="light" mt={2}>
              <IconInfoCircle size={16} />
            </ThemeIcon>
            <Text size="sm" c="dimmed">
              Bu sürümde departmana bağlı harcama alanı ve malzeme kodu bazlı kalem seçimi eklendi.
              Sonraki aşamada malzeme koduna göre stok, kategori, bütçe ve depo bağlantısı da kurulabilir.
            </Text>
          </Group>
        </Paper>
      </Stack>
    </Container>
  );
}